export default "__VITE_ASSET__i8XA9vAl__"